<template>
  <div class="s-tabbar">
    <!-- <div class='tabbar-item' :class="{'active':page=='home'}" @click="changePath('home')">
      <div class="item-icon ico ico-home"  :class="{'active':page=='home'}"></div>
			<div class="item-txt"> 首页 </div>
    </div> -->
		<div class='tabbar-item'  :class="{'active':page=='path'}" @click="changePath('path')">
		  <div class="item-icon iconfont2 icon-luxian"  :class="{'active':page=='path'}"></div>
			<div class="item-txt"> 路线 </div>
		</div>
    <div class='tabbar-item'  :class="{'active':page=='order'}" @click="changePath('order')" v-if="openid">
		  <div class="item-icon iconfont2 icon-menpiao" :class="{'active':page=='order'}" ></div>
			<div class="item-txt"> 门票 </div>
		</div>
		<div class='tabbar-item' @click="changePath('share')">
		  <div class="item-icon iconfont2 icon-fenxiang"></div>
			<div class="item-txt"> 分享 </div>
		</div>
  </div>
</template>
<script>
  export default{
    props:{page:String},
    data(){
      return{
        openid:window.openid
      }
    },
    methods: {
      changePath(page){
        this.$emit('change',page)
      }
    },
  }
</script>
<style lang="scss">
	
  .s-tabbar{
		background:#fff;
		height:59rem;
		// border-radius:25rem;
    box-shadow: 0 4rem 10rem 0 rgba(0,0,0,0.3);
    // bottom: 20rem;
    width: calc(100vw - 60rem);
    // max-width: 650rem;
    border-radius:30rem;
    // width: 100vw;
    bottom: 40rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: fixed;
    left: 50%;
    transform: translate(-50%);
    z-index: 10;
    box-sizing: border-box;
    padding: 0 15rem;
    .tabbar-item{
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      color: #666666;
      cursor: pointer;
      .item-txt{
        font-size: 12rem;
      }
      .item-icon{
        font-size: 20rem;
        width: 20rem;
        height: 20rem;
        margin-bottom: 2rem;
      }
      &.active{
        color: var(--mainColor);
      }
    }
  }
</style>